import React from "react";
import { Link, useParams } from "react-router-dom";
import { articleByKey } from "./articles";

/**
 * Статья Книги Знаний внутри кабинета.
 *
 * Формат общий с уроками курса — вступление, пронумерованные блоки, вывод:
 * человек не должен переучиваться, переходя из обучения в справочник.
 */

const PUBLIC = process.env.PUBLIC_URL || "";

const ArticlePage = () => {
  const { key } = useParams();
  const article = articleByKey(key);

  if (!article) {
    return (
      <div className="fw-page">
        <Link className="fw-back" to={`${PUBLIC}/knowledge`}>
          ← В Книгу Знаний
        </Link>
        <h1 className="fw-title">Статья не найдена</h1>
        <p className="fw-sub">
          Возможно, она ещё не перенесена — откройте оглавление и найдите её там.
        </p>
      </div>
    );
  }

  return (
    <div className="fw-page fw-lesson">
      <Link className="fw-back" to={`${PUBLIC}/knowledge`}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M15 18l-6-6 6-6" />
        </svg>
        В Книгу Знаний
      </Link>

      <div className="fw-lesson-head">
        <span className="fw-chip">
          {article.section} · {article.minutes} мин
        </span>
        <h1 className="fw-title">{article.title}</h1>
        <p className="fw-sub mb-0">{article.lead}</p>
      </div>

      {article.intro ? (
        <section className="fw-card fw-lesson-outcome">
          <p style={{ margin: 0 }}>{article.intro}</p>
        </section>
      ) : null}

      <div className="fw-lesson-blocks">
        {article.blocks.map((b, i) => (
          <section className="fw-card fw-lesson-block" key={b.title}>
            <span className="n">{i + 1}</span>
            <div>
              <b>{b.title}</b>
              <p>{b.text}</p>
            </div>
          </section>
        ))}
      </div>

      {article.outcome ? (
        <section className="fw-card fw-lesson-outcome">
          <b>Коротко</b>
          <p>{article.outcome}</p>

          <div className="fw-lesson-acts">
            <Link className="fw-btn ghost" to={`${PUBLIC}/knowledge`}>
              Другие статьи
            </Link>
            <Link className="fw-btn ghost" to={`${PUBLIC}/learning`}>
              К урокам курса
            </Link>
          </div>
        </section>
      ) : null}
    </div>
  );
};

export default ArticlePage;
